import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Client, UtilityDto } from '../../../api/api-reference';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-utility-details',
  standalone: true,
  imports: [
    TranslateModule,
    AngularSvgIconModule,
    DatePipe
  ],
  templateUrl: './utility-details.component.html',
  styleUrl: './utility-details.component.scss'
})
export class UtilityDetailsComponent implements OnInit {
  @Input() utilityId: string = '';
  @Output() close = new EventEmitter<boolean>();
  utility: UtilityDto = new UtilityDto();

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getUtilityById();
  }

  toggleModal() {
    this.close.emit();
  }

  getUtilityById() {
    this.client.getUtility(this.utilityId).subscribe({
      next: (result) => {
        this.utility = result;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}